import React, { useEffect, useState } from "react";
import { Box, Typography, Divider, Tooltip, IconButton } from "@mui/material";
import DashboardLayout from "../../../layouts/DashboardLayout/DashboardLayout";
import PaginationTable from "../../../components/PaginationTable";
import { useNavigate } from "react-router-dom";
import BasicButtons from "../../../components/Button";
import { toast } from "react-hot-toast";
import EditIcon from "@mui/icons-material/Edit";
import backBtn from "../../../assets/backBtn.svg";
import typographyStyles from "../../../theme/Typography";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  getDataHandler,
  deleteDataHandler,
  getDataHandlerWithToken,
} from "../../../apiconfig/service";
import moment from "moment";
import DataNotFound from "../../../components/DataNotFound";

const columns = [
  { id: "sr_no", label: "Sr.No." },
  { id: "categoryName", label: "Name" },
  { id: "created_date_time", label: "Created Date & Time" },
  { id: "action", label: "Action" },
];

const ListBlogs = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [statisticsData, setBlogsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getDataHandlerWithToken("viewBlogCategories");
        if (response?.responseCode === 200) {
          setBlogsData(response.result);
        } else {
          toast.error(
            response?.responseMessage || "Failed to fetch statistics"
          );
        }
      } catch (error) {
        console.error("Error in fetching data", error);
        toast.error("Failed to fetch statistics");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleEdit = (statisticsData) => {
    navigate(`/staticcontent/listBlogs/editBlogStage`, {
      state: { statisticsData },
    });
  };

  const handleClickOpen = (statisticsData) => {
    navigate(`/staticcontent/listBlogs/viewBlogs`, {
      state: { statisticsData },
    });
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  return (
    <DashboardLayout
      sectionName="Static Content Management"
      title="Blogs Management"
    >
      <Box className="heading-container-top">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Box>
            <img
              src={backBtn}
              alt="backBtn"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/staticcontent")}
            />
          </Box>
          <Typography sx={{ ...typographyStyles.h4 }}>
            Blog Management
          </Typography>
        </Box>
      </Box>
      <br />
      <Divider />
      <Box className="StaticScreenContainer">
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            {/* Add a Loading component if needed */}
          </Box>
        )  : statisticsData?.length < 1 ? (
          <DataNotFound/>
        ) : (
          <PaginationTable
            columns={columns}
            data={statisticsData?.map((item, index) => ({
              sr_no: index + 1,
              categoryName: item?.categoryName,
              created_date_time: moment(item.createdAt).format(
                "MM/DD/YYYY, h:mm A"
              ),
              action: (
                <Box className="row-button-container">
                 
                  <IconButton
                    onClick={() => handleClickOpen(item)}
                    sx={{ color: "rgb(225,140,168)" }}
                  >
                    <VisibilityIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => handleEdit(item)}
                    sx={{ color: "rgb(225,140,168)" }}
                  >
                    <EditIcon />
                  </IconButton>
                </Box>
              ),
            }))}
          />
        )}
      </Box>
      {/* {open && (
        <DeleteModal
          open={open}
          handleClose={handleClose}
          handleDelete={handleDeleteConfirm}
          title="Delete Item?"
          description={`Are you sure you want to delete the statistic titled "${selectedRow?.title}"? This action cannot be undone.`}
        />
      )} */}
    </DashboardLayout>
  );
};

export default ListBlogs;
